import React, {Component} from 'react';
import classNames from 'classnames';

import styles from './Link.less';

export default class Link extends Component {
	render() {
		const {
			children,
			icon,
			className,
			...props
		} = this.props;

		const isExtended = !!icon;

		const link_classes = classNames(styles['link'], className, {
			[styles['link_extended']]: isExtended
		});

		return (
			<a className={link_classes} {...props}>
				{icon && (
					<span className={styles.link__icon}>
						{icon}
					</span>
				)}
				{isExtended ? (
					<span className={styles.link__text}>
						{children}
					</span>
				) : children}
			</a>
		);
	}
}